module.exports = {
  assets: {
    host: '//www.spot.im'
  },
  prerender: {
    host: '0.0.0.0',
    port: 5100,
    secure: false
  },
  rollbar: {
    accessTokens: {
      postServerItem: 'a0681e19ebe54db1aa2b7b55251565d0'
    }
  },
  centry: 'https://7eb552bc11ad4997a19057f236d49cc2@sentry.spot.im/20',
  twitterFrame: '//www.spot.im/embed/entities-frames/twitter/index.html',
  instagramFrame:
    'https://app-cdn.spot.im/modules/prerender/1f2b316bf8c/conversation/entities-frames/instagram/index.html',
  hostPanelV2: 'https://host-panel-v2.spot.im/spots/',
  api: {
    hostpanelV2Logout: 'https://host-panel-v2.spot.im/api/cpv2_logout',
    communitySpoxy: 'https://community-spoxy.spot.im',
    spoxy: 'https://spoxy-shard4.spot.im/v2/spot/:spotId/post/:postId/',
    launcher: 'https://launcher.spot.im/bundle.js',
    newLauncher: 'https://launcher.spot.im/spot/{{SPOT_ID}}',
    launcherOnly: 'https://launcher.spot.im',
    standaloneConversation: 'https://www.spot.im/embed/modules/conversation/standalone/index.html',
    login: 'https://admin.spot.im/login',
    basic: 'https://admin.spot.im/',
    starsRating: 'https://launcher.spot.im/bundle.js?module=stars-rating',
    urls: {
      // exportMonetization:
      //   'https://mc-reporting.spot.im/bd1b56e6e389c04f/monetization_data?spot_id=:spotId&from=:from&to=:to&format=csv',
      setPassword: 'https://admin.spot.im/set-password',
      pageNotFound: 'https://admin.spot.im/page-not-found',
      //recirculation: 'https://www.spot.im/embed/modules/launcher/bundle.js?module=recommendations',
      recirculationOnly: 'https://recirculation.spot.im',
      recirculation: 'https://recirculation.spot.im/spot/',
      liveBlog: 'https://www.spot.im/embed/modules/launcher/bundle.js?module=live-blog',
      blog: 'https://blog.spot.im/',
      about: 'https://www.spot.im/about/',
      jobs: 'https://www.spot.im/jobs/',
      developers: 'https://developers.spot.im/',
      support: 'https://support.openweb.com/',
      contact: 'https://www.spot.im/contact/',
      privacy: 'https://www.openweb.com/legal-and-privacy/privacy/',
      terms: 'https://www.openweb.com/legal-and-privacy/terms-of-use/'
    },
    socialConnect: {
      url: 'https://social-connect.spot.im',
      cdn: 'https://www.spot.im/api/social-connect',
      callbackUrl: 'https://www.spot.im/embed/social-login.html'
    }
  },
  contextHubUrl: 'https://www.spot.im/embed/modules/context-hub/hub/index.html',
  cookieBaseDomain: 'admin.spot.im',
  MIX_PANEL_TOKEN: '6703160c04c5a4b663ea706aff23bf7d'
};
